var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule"},[_c('LogoTitle',{attrs:{"msg":"基金会章程"}}),_c('div',{staticClass:"rule-title"},[_vm._v("思利及人基金会章程")]),_c('RichArticle',{attrs:{"html":_vm.html}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }